import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_text.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconText = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconText;
